import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LanguageService } from '../providers/common.services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { ViewDemoComponent } from '../view-demo/view-demo.component';

@Component({
  selector: 'app-ai-chat-bot',
  templateUrl: './ai-chat-bot.page.html',
  styleUrls: ['./ai-chat-bot.page.scss'],
})
export class AiChatBotPage implements AfterViewChecked {
  entityDetails: any;
  userid: any;
  lang:any;

  @ViewChild('scrollMe') private myScrollContainer!: ElementRef;

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  constructor(private ngZone: NgZone,private cdRef: ChangeDetectorRef,public modalController: ModalController,private langDir: LanguageService,public translate: TranslateService) {
    this.entityDetails = JSON.parse(localStorage.getItem('sitename'));
    this.userid = localStorage.getItem('userid');
    this.lang = localStorage.getItem('lang') == null ? 'en' : localStorage.getItem('lang');
      langDir.SiteLanguage$.subscribe(data => {
        console.log('vengi', data);
        if (data === 'ltr') {
          this.lang = 'en';
          this.translate.setDefaultLang('en');
          this.translate.use('en');
          // this.goBackToList();
        }
        else {
          this.lang = 'ar';
          this.translate.setDefaultLang('ar');
          this.translate.use('ar');
          // this.goBackToList();
        }
      });
      console.log('vengitest==>',this.lang)
      // this.goBackToList();
  }

  ngOnInit() {
    this.streaming = true;
    setTimeout(() => {
    this.messages.push({ sender: 'assistant', text: 'Hello! How can I assist you today?' });
    this.streaming = false;
    }, 1000);
  }

  messages: { sender: string, text: string }[] = [];
  userMessage: string = '';
  streaming: boolean = false;

  async sendMessage1() {
    if (!this.userMessage.trim()) return;

    // Push user message
    this.messages.push({ sender: 'user', text: this.userMessage });

    const msg = this.userMessage;
    this.userMessage = '';
    this.scrollToBottom();

    // Placeholder for assistant
    let assistantMsg = { sender: 'assistant', text: '' };
    this.messages.push(assistantMsg);

    this.streaming = true;

    try {
      let streamUrl:any = this.entityDetails.api_url + 'api/aichatbot/chatStream/'+this.userid;
      const response = await fetch(streamUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ content: msg,user_id: this.userid })
      });

      if (!response.body) throw new Error('No response body');

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        // Split on newlines (because events are sent line by line)
        let parts = buffer.split(/\r?\n/);
        buffer = parts.pop() || ''; // keep incomplete part for next chunk

        for (const line of parts) {
          if (line.startsWith('event:')) {
            // Capture event name if needed
            continue;
          }
          if (line.startsWith('data:')) {
            try {
              const data = JSON.parse(line.replace(/^data:\s*/, ''));

              if (data.type === 'text') {
                assistantMsg.text += data.text;
              } else if (data.type === 'status') {
                console.log('Status update:', data.status);
              } else if (data.type === 'done') {
                console.log('Streaming complete');
              }
            } catch (err) {
              console.error('Failed to parse:', line);
            }
          }
        }
      }
    } catch (err) {
      console.error('Stream error:', err);
      assistantMsg.text += '\n[Error receiving response]';
    } finally {
      this.streaming = false;
      this.scrollToBottom();

    }
  }

async sendMessage() {
  if (!this.userMessage.trim()) return;

  // Push user message
  this.messages.push({ sender: 'user', text: this.userMessage });

  const msg = this.userMessage;
  this.userMessage = '';

  // Scroll after adding user message
  this.scrollToBottom();

  // Placeholder for assistant
  let assistantMsg = { sender: 'assistant', text: '' };
  this.messages.push(assistantMsg);

  // Scroll after adding assistant placeholder
  this.scrollToBottom();

  this.streaming = true;

  try {
    const streamUrl: any = `${this.entityDetails.api_url}api/aichatbot/chatStream/${this.userid}`;
    const response = await fetch(streamUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content: msg, user_id: this.userid })
    });

    if (!response.body) throw new Error('No response body');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const parts = buffer.split(/\r?\n/);
      buffer = parts.pop() || '';

      for (const line of parts) {
        if (line.startsWith('event:')) continue;

        if (line.startsWith('data:')) {
          try {
            const data = JSON.parse(line.replace(/^data:\s*/, ''));

            if (data.type === 'text') {
              assistantMsg.text += data.text;
              this.scrollToBottom();  // Scroll as assistant types
            }

          } catch (err) {
            console.error('Failed to parse:', line);
          }
        }
      }
    }

  } catch (err) {
    console.error('Stream error:', err);
    assistantMsg.text += '\n[Error receiving response]';
    this.scrollToBottom();
  } finally {
    this.streaming = false;
    this.scrollToBottom();
  }
}

async DemoModal() {
  let data,e;
    const modal = await this.modalController.create({
      component: ViewDemoComponent,
      cssClass: 'my-team-class',
      componentProps:{type:e,List:data}
    });
    return await modal.present();
  }

  // async DemoModal(e,data) {
  //   const modal = await this.modalController.create({
  //     component: ViewDemoComponent,
  //     cssClass: 'my-team-class',
  //     componentProps:{type:e,List:data}
  //   });
  //   return await modal.present();
  // }


  // scrollToBottom(): void {
  //   try {
  //     this.myScrollContainer.nativeElement.scrollTop =
  //       this.myScrollContainer.nativeElement.scrollHeight;
  //   } catch (err) {}
  // }

  scrollToBottom(): void {


  try {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.cdRef.detectChanges();  // Ensure DOM updated
        const container = this.myScrollContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }, 100);  // Slight delay to ensure DOM rendering completes
    });
  } catch (err) {}
}




}
